module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/home/runner/work/webapp/webapp/vendor/semantic/dist/semantic.min.js"));
    }, "semantic-js");
  });
}